/**
 * 得獎名單公佈時間
 */
const ANNOUNCE_WINNER_DATE = '2025-03-19 00:00:00'

export { ANNOUNCE_WINNER_DATE }